import React from "react";
import { NodeCollectionStore, NodeStore } from "./stores";
import { HALF, VIEWPORT_CENTER_X, VIEWPORT_CENTER_Y } from "./Constants";

/**
 * This is a class that contains static methods. 
 * This means that the methods you write here can be accessed in the same way from anywhere else in the project (as long as this file is imported)
 * You do not need to make changes to this for the starter project (but you can!)
 */
export class Utils {

    /**
     * @returns an 8-4-4-4-12 character alphanumeric string
     */
    public static GenerateGuid() {

        /**
         * @returns a 4-character alphanumeric string
        */
        const s4 = () => Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);

        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    }
}

/**
 * This method applies drag movement to a node.
 * @param node The node being dragged.
 * @param event The event tontaining movementX and movementY.
 */
export function dragNode(node: NodeStore, event: PointerEvent) {
    node.x += event.movementX;
    node.y += event.movementY;
}

/**
 * This method returns coordinates at the center of the viewport.
 * @returns an object containing x and y coordinates
 */
export function createAtCenter() {
  return {
    x: VIEWPORT_CENTER_X(),
    y: VIEWPORT_CENTER_Y(),
  };
}

/**
 * This method centers the root node collection on the screen. 
 * @param root The root collection to move.
 * @param node The node to center on.
 */
export function centerRoot(root: NodeCollectionStore, node: NodeStore) {
    root.x = -node.x + window.innerWidth * HALF - node.width * HALF;
    root.y = -node.y + window.innerHeight * HALF - node.height * HALF;
}

/**
 * This method factors out panning math for nodes.
 * @param store The node being panned.
 * @param deltaX The change in x position.
 * @param deltaY The change in y position.
 */
export function panningMath(
  store: NodeStore,
  deltaX: number,
  deltaY: number
): void {
  store.x += deltaX;
  store.y += deltaY;
}